export enum SapEtaConfigurationEndpoint {
  Base = '/sap',
  AccessProperties = '/access-properties',
}
